import { css, HStack, NavItem, styled } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { NotificationCounter } from '../../common/components/notification-counter';
import { useActiveConversationsUnreadInfo } from '../../common/hooks/use-active-conversations-unread-info';
import { useNavDrawers } from './use-nav-drawer';
import { getNavigationNotificationsStyle } from './helpers';
import { useGetDisplayedShortcutKeyByCommand } from './use-shortcut-key-by-command';

// @ts-expect-error
const StyledNavItem = styled(NavItem)<{ $isUnreadCount: boolean }>`
    margin-top: 0;

    & svg {
        width: 24px;
        height: 24px;
    }

    ${({ $isUnreadCount }) =>
        $isUnreadCount &&
        css`
            background-color: var(--arc-colors-warning-accent);
            &:before {
                background-color: var(--arc-colors-warning-accent);
                border: 1px solid var(--arc-colors-selected-default);
            }
        `};
`;

//TODO: why is this not an FrNavItem?
export const MessagingNavItem = observer(function MessagingNavItem(): ReactElement {
    const { isDrawerOpen, toggleDrawer } = useNavDrawers('fr-messaging');
    const { unreadCount, hasUrgentUnread } = useActiveConversationsUnreadInfo();
    const getDisplayedShortcutKeyByCommand = useGetDisplayedShortcutKeyByCommand();

    return (
        <HStack position="relative">
            <StyledNavItem
                icon="Messaging"
                label={getDisplayedShortcutKeyByCommand('TOGGLE_MESSAGING_PANEL')}
                isActive={isDrawerOpen}
                $isUnreadCount={!!unreadCount}
                data-testid="messaging-link-nav"
                style={{ marginBottom: 8 }}
                onClick={toggleDrawer}
            />
            <NotificationCounter
                isUrgent={hasUrgentUnread}
                style={getNavigationNotificationsStyle(unreadCount)}
            >
                {unreadCount}
            </NotificationCounter>
        </HStack>
    );
});
